import React from 'react'
import { AuthenticationContext, IMkAuthenticationServiceContext } from '../contexts/core'

export const useAuthentication = (): IMkAuthenticationServiceContext => {
  const context = React.useContext(AuthenticationContext)
  if (context === undefined) {
    throw new Error('useAuthentication must be used within an AuthenticationProvider')
  }
  return context
}
